
import { Component, OnInit } from '@angular/core'
import { NotificationService } from '../../../../services/notification.service'
import { Router } from '@angular/router'
import { OperationServiceService } from '../../../../services/operation.service.service'

import { CompanyService } from 'src/app/services/company.service'
import { getLoggedUser, setHasMultipleCompanyProviders } from 'src/app/_helpers/LocalStorage'
import { UserAdmin } from 'src/app/models/UserAdmin'
import { PreScheduleOperationServiceDto } from './dto/pre-scheduling.dto'
import { removeToolTip } from 'src/app/_helpers/Utils'
import { IHandlerOperation } from 'src/app/models/HandlerOperation'
import { HandlerOperationService } from 'src/app/services/handler.operation.service'

@Component({
	selector: 'app-pre-scheduling-operation',
	templateUrl: './operation-service-pre-scheduling.component.html'
})
export class PreScheduleOperationServiceComponent implements OnInit {

	public companyId: string
	public operationIndex = 0
	public modalDetailsSpecie: boolean = false
	public isAdmin: boolean = false
	public showSelectHandleOperations: boolean = false
	public sessionUser: UserAdmin = getLoggedUser()

	public perPage = 10
	public page = 1
	public isLoading = false

	// Carrousel

	public carouselPages: number = 0
	public carouselPageNow: number = 1
	public arrowLeftEnable: boolean = false
	public arrowRightEnable: boolean = true
	public photoFromCarouselEnable: boolean = false
	public photoFromCarousel: string

	constructor(
		private router: Router,
		private companyService: CompanyService,
		private notificationService: NotificationService,
		private operationServiceService: OperationServiceService,
		private readonly handlerOperationService: HandlerOperationService
	) {
	}

	public operations: Array<PreScheduleOperationServiceDto> = []
	public handlerOperations: Array<IHandlerOperation> = []
	private initialVersionOfOperations: Array<PreScheduleOperationServiceDto> = []
	public countOperations: number = 0

	public async ngOnInit() {
		const topPage = document.getElementsByClassName('main-content')[0]

		topPage.scrollIntoView({
			behavior: 'smooth'
		})

		this.isAdmin = getLoggedUser().roles.includes('GENERAL_ADMIN')
		this.companyId = localStorage.getItem('companyId')

		if (!(this.sessionUser.assignments.includes('OPERATION_SERVICE_SCHEDULE_CREATE') || this.isAdmin)) {
			this.notificationService.notify('Você não tem permissão para agendar operações de manejo', 403)
			this.router.navigate(['/panel'])
		}
		
		this.getOperations()

		if (
			this.sessionUser.assignments.includes('OPERATION_SERVICE_SCHEDULE_UPDATE') ||
			this.isAdmin
		) {
			await this.getHandlerOperations()
		}
	}

	public getOperations(page = 1, perPage = 10) {
		const operationsLocalStorage: Array<string> = JSON.parse(localStorage.getItem('operationService'))

		if (!operationsLocalStorage || operationsLocalStorage.length === 0) {
			this.notificationService.notify('Não há operações para agendar', 404)
			this.router.navigate(['/panel/management/operationService'])
		}

		const operationsIds = operationsLocalStorage.join(',')

		this.operationServiceService.getOperationsPreScheduling(operationsIds, this.companyId, page, perPage).subscribe(data => {
			this.page = page++

			this.operations = [...this.operations, ...data.operations]
			this.initialVersionOfOperations =
				[...this.initialVersionOfOperations, ...JSON.parse(JSON.stringify(data.operations))]
			this.countOperations = data.count

			this.setHasMultipleCompanyProviders()
			setTimeout(this.setupCarousel, 2000)
		})
	}

	public async getHandlerOperations(): Promise<void> {
		this.handlerOperations =
			await this.handlerOperationService.list(this.companyId, false).toPromise()
	}

	public setupCarousel() {
		const carouselWidth: number = document.getElementById('carrossel').offsetWidth
		const cardsPerPage = Math.floor(carouselWidth / 294)
		this.carouselPages = Math.floor(this.operations[this.operationIndex].gallery.length  / cardsPerPage)
	}

	public async back() {
		this.router.navigate(['/panel/management/operationService'])
		localStorage.removeItem('operationService')
		localStorage.removeItem('cameFromScheduleMap')
		localStorage.removeItem('baseCoordinatesOperation')
	}

	public scrollUp() {
		const steps: HTMLDivElement = document.getElementById('main') as HTMLDivElement

		steps.scrollIntoView({
			behavior: 'smooth'
		})
	}

	public previousOperation() {
		if (this.operationIndex > 0) {
			this.operationIndex--

			this.scrollUp()
		}
	}

	public nextOperation() {
		if (
			this.operationIndex < this.countOperations - 1
		) {
			this.operationIndex++

			this.scrollUp()

			this.resetCarousel()
		}

		if (this.operationIndex === this.operations.length - 2 && this.operations.length < this.countOperations) {
			this.isLoading = true
			this.getOperations(this.page + 1, this.perPage)
			this.isLoading = false
		}
	}

	public resetCarousel() {
		const carousel = document.getElementById('carousel-content') as HTMLDivElement
		const carouselWidth: number = document.getElementById('carrossel').offsetWidth
		const cardsPerPage = Math.floor(carouselWidth / 294)
		this.carouselPages = Math.floor(this.operations[this.operationIndex].gallery.length  / cardsPerPage)
		this.carouselPageNow = 1
		this.arrowLeftEnable = false
		this.arrowRightEnable = true
		carousel.style.left = `-${carouselWidth * (this.carouselPageNow - 1)}px`
	}

	public async navigateToSchedule() {

		const operationsModified: Array<PreScheduleOperationServiceDto> =
			this.operationsWithChanges()

		if (operationsModified.length > 0) {
			try {
				const response =
					await this.operationServiceService.updateOperationsFromScheduler(
						operationsModified,
						this.companyId
					).toPromise()

				this.notificationService.notify(response, 200)
				this.router.navigate(['/panel/operation/schedule'])
			} catch (error) {
				this.notificationService.notify(error.error.message, 500)
			}
		} else {
			this.router.navigate(['/panel/operation/schedule'])
		}
	}

	public openCloseModalDetailsSpecie() {
		this.modalDetailsSpecie = !this.modalDetailsSpecie
	}

	public moveCarousel(direction: 'left' | 'right') {
		const carousel = document.getElementById('carousel-content') as HTMLDivElement
		const carouselWidth: number = document.getElementById('carrossel').offsetWidth

		if (direction == 'left') {
			if (this.carouselPageNow > 1) {
				this.carouselPageNow--
			}
		}
		if (direction == 'right') {
			if (this.carouselPageNow < this.carouselPages) {
				this.carouselPageNow++
			}
		}

		if (this.carouselPageNow > 1) {
			this.arrowLeftEnable = true
		} else {
			this.arrowLeftEnable = false
		}

		if (this.carouselPageNow == this.carouselPages) {
			this.arrowRightEnable = false
		} else {
			this.arrowRightEnable = true
		}

		const carouselPosition: number = carouselWidth * (this.carouselPageNow - 1)
		carousel.style.left = `-${carouselPosition}px`
	}

	public openClosePhotoFromCarousel(photo: string) {
		this.photoFromCarouselEnable = !this.photoFromCarouselEnable
		this.photoFromCarousel = photo

		removeToolTip()
	}

	public openSelectorHandlerOperations() {
		this.showSelectHandleOperations = true
	}

	public closeSelectorHandlerOperations(
		event: Array<{
			idMongo: string,
			operation: string
		}>
	) {
		this.showSelectHandleOperations = false
		this.operations[this.operationIndex].handlerOperations = event
	}

	public operationsWithChanges(): Array<any> {
		const operationsWithChanges = []

		for (let i = 0; i < this.initialVersionOfOperations.length; i++) {
			const initialOperation = this.initialVersionOfOperations[i]
			const currentOperation = this.operations[i]

			if (!this.compareOperations(initialOperation, currentOperation)) {
				operationsWithChanges.push(currentOperation)
			}
		}

		return operationsWithChanges
	}

	public compareOperations(
		initialOperation: PreScheduleOperationServiceDto,
		beforeOperation: PreScheduleOperationServiceDto
	): boolean {
		const editableFields = [
			'handlerOperations'
		]

		for (const field of editableFields) {
			if (JSON.stringify(initialOperation[field]) !== JSON.stringify(beforeOperation[field])) {
				return false
			}
		}

		return true
	}

	private setHasMultipleCompanyProviders() {
		const distinctCompanyProviderIds = new Set(
			this.operations.filter(op =>
				op.companyProviderId !== undefined
			).map(op => op.companyProviderId)
		  )

		setHasMultipleCompanyProviders(distinctCompanyProviderIds.size > 1)
	}
}
